import { gql } from 'apollo-angular'

import { ORGANIZATION_RESELLER_REQUEST_FIELDS } from '../../fragments/organization-reseller-request.fragment'

export const CREATE_ORGANIZATION_RESELLER_REQUEST = gql`
  mutation CreateOrganizationResellerRequest(
    $data: mutationOrganizationResellerRequestInput!
  ) {
    createOrganizationResellerRequest(data: $data) {
      ...OrganizationResellerRequestFields
    }
  }
  ${ORGANIZATION_RESELLER_REQUEST_FIELDS}
`
